/* eslint-disable camelcase */
import { TrackingBtx, TrackingProductType, TrackingTargetAudience } from '@vfde-sails/tracking';
import { TrackingProduct, TrackingProposition } from './interface';
import { JarvisProduct } from '../interface';

export const pageLevels = window.VF?.siteStructure
    ? [...window.VF.siteStructure]
    : [];

/**
 * Get discount tracking string
 * @param {number | string} value - value to convert
 * @returns {string} - discount price
 */
export const getDiscountString = (value: number | string) => `-${Math.abs(+value).toFixed(2)}`;

/**
 * Get tracking aPropositon object for the selected page and product.
 * @param {JarvisProduct} product - selected product
 * @returns {TrackingProposition} - tracking proposition object
 */
export const getTrackingProposition = (product: JarvisProduct): TrackingProposition => ({
    id: 1,
    name: product.id,
    target_audience: TrackingTargetAudience.Consumer,
    retention: TrackingBtx.Bnt,
    product_type: 'cis',
    product_line: '1p - tv',
    product_category: TrackingProductType.Tariff,
    units: 1,
});

/**
 * Get a TrackingProduct from a JarvisProduct
 * @param {JarvisProduct} product - selected product
 * @returns {TrackingProduct} - result tracking product
 */
export const getTrackingProduct = (product: JarvisProduct): TrackingProduct => ({
    sku: product.id,
    name: product.id,
    type: 'cis',
    duration: +product.duration,
    proposition: 1,
    units: 1,
    price_monthly: product.price.value.toString(),
});

/**
 * Get a TrackingProduct for stairway price from a JarvisProduct
 * @param {JarvisProduct} product - selected product
 * @returns {TrackingProduct} - result tracking product
 */
export const getTrackingDiscount = ({ price }: JarvisProduct): TrackingProduct => ({
    sku: 'Discount',
    name: 'Discount',
    type: 'cis',
    duration: price.stairway.period,
    price_monthly: getDiscountString(price.value - price.stairway.value),
    proposition: 1,
    units: 1,
});

/**
 * Formats the given string to lowercase, separates words
 * if they are next to each other without space and removes
 * any additional whitespaces and replaces the special
 * German letters in the text to basic latin letters
 * (e.g. `ß` to `ss`, `ä` to `ae`, and so on).
 * This step is requested by Digital Power,
 * to process the incoming data more easily.
 */
export const formatToTrackingString = (text: string, maxLength = 100): string =>
    text.replace(/([a-z])([A-Z])/g, '$1 $2')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ')
        .substring(0, maxLength)
        .replace(/\u00e4/g, 'ae')
        .replace(/\u00f6/g, 'oe')
        .replace(/\u00fc/g, 'ue')
        .replace(/\u00df/g, 'ss');
